import React, { useEffect, useState, useMemo } from "react";
import { AiOutlineHeart, AiFillHeart } from "react-icons/ai";
import { has, toggle, add } from "../../services/wishlistService";
import "./productDetails.css";

/**
 * props:
 * - article: { codArt, name/lib/LibArt, price/PrixTTC, image, link? }
 * - fallbackId?: string  (si on a seulement un id)
 */
export default function ProductWishlistButton({ article, fallbackId }) {
  // Normalise minimal
  const normalized = useMemo(() => {
    if (article) {
      const codArt = article.codArt || article.CodArt || article.ref || article.RefArt;
      const name = article.name || article.lib || article.LibArt || "Article";
      const price = typeof article.price === "number" ? article.price : (article.PrixTTC ?? null);
      const image = article.image || article.img || null;
      const link = article.link || (codArt ? `/produits/${encodeURIComponent(codArt)}` : "#");
      const rawItem = article.rawItem || null;      // ✅ AJOUT
    return { codArt, name, price, image, link, rawItem };
    }
    if (fallbackId) return { codArt: fallbackId };
    return null;
  }, [article, fallbackId]);

  const [liked, setLiked] = useState(false);

  useEffect(() => {
    if (!normalized?.codArt) return setLiked(false);
    // si on a des infos complètes, on s'assure qu'elles sont persistées quand l'article est déjà “liké”
    if (has(normalized.codArt) && (normalized.name || normalized.price || normalized.image)) {
      add(normalized);
    }
    setLiked(has(normalized.codArt));
  }, [normalized]);

  const onToggle = () => {
    if (!normalized?.codArt) return;
    const nv = toggle(normalized);
    setLiked(nv);
  };

  return (
    <button
      className={`wishBtn ${liked ? "is-liked" : ""}`}
      onClick={onToggle}
      aria-pressed={liked}
      title={liked ? "Retirer de la wishlist" : "Ajouter à la wishlist"}
      type="button"
    >
      {liked ? <AiFillHeart size={20} /> : <AiOutlineHeart size={20} />}
      <span>{liked ? "Dans la wishlist" : "Add to Wishlist"}</span>
    </button>
  );
}
